<template lang="pug">
  div.player-title-container
    div.logo-container
      img.logo(:src="logo")
      span.title {{ $t('Tencent Interactive Live Streaming') }}
    div.right-container
      comp-language(pageName="live-list")
      comp-user-info(:showUserInfo="!$isMobile")
</template>

<script>
import logo from 'assets/img/logo.png';
import compLanguage from '@/components/comp-header/comp-language';
import compUserInfo from '@/components/comp-header/comp-user-info';
export default {
  name: 'player-title',
  data() {
    return {
      logo,
    };
  },
  components: {
    compLanguage,
    compUserInfo,
  },
};
</script>

<style lang="stylus" scoped>
.player-title-container
  width 100%
  height 100%
  position relative
  display flex
  justify-content flex-start
  .logo-container
    height 36px
    position absolute
    left 4px
    top 50%
    margin-left 14px
    transform translateY(-50%)
    font-size 18px
    display flex
    align-items center
    .logo
      height 20px
      vertical-align bottom
    .title
      margin-left 10px
  .right-container
    height 100%
    position absolute
    top 0
    right 14px
    display flex
    align-items center
    & > :not(:first-child)
      margin-left 16px
</style>

<i18n>
{
	"en": {
		"Tencent Interactive Live Streaming": "Interactive Live Streaming"
	},
	"zh": {
		"Tencent Interactive Live Streaming": "腾讯云互动直播"
	}
}
</i18n>
